export default "__VITE_ASSET__4eafd161__"